import { formatDateTime } from 'apm/utils/dates';
import './SpiEmailDisapatcher.css';
import { spi_email_status } from 'apm/schemas/spi_email_dispatcher';
import { CellSkeleton } from '../reports/daily-report/DailyReportComponents/DailyReportSkeleton';


type PropsType ={
  status: string,
  approved_on: string,
  approved_by: string,
  formApiStatus: string

}
export default function SpiEmailMetaData({status, approved_on, approved_by, formApiStatus}: PropsType){

  const filterEmailStatus =(status : string) =>{
    switch(status){
      case spi_email_status.approved:
        return <div className='text-success'>Approved</div>;
      case spi_email_status.rejected:
        return <div className='text-danger'>Rejected</div>;
      case spi_email_status.pending:
        return <div>Pending</div>;
      default:
        return <div>{status}</div>;
    }
  }

  const skeltonelement =() =>{
    return  <div style={{width: "150px"}}><CellSkeleton /></div>
  }


return (
  <>
  <table className='meta-table'>
  <tbody>
<tr>
    <td>Email status:</td>
    <td> {formApiStatus == 'running' ? skeltonelement():  filterEmailStatus(status) }  </td>
</tr>
<tr>
    <td>Email {status == 'Rejected' ? status : "Approved"} on:</td>
    <td>{formApiStatus == 'running' ? skeltonelement():  formatDateTime(approved_on)}</td>
</tr>
<tr>
    <td>Email {status == 'Rejected' ? status : "Approved"} by:</td>
    <td>{formApiStatus == 'running' ? skeltonelement() :  approved_by}</td>
</tr>
</tbody>
</table>
  </>
)
}